<app-nav></app-nav>
<section class="viewEndorsements container-fluid mt-3">
  <div class="d-flex justify-content-center">
    <span id="snackbarEndo"></span>
  </div>
  <div class="modal modalPositionEndo" tabindex="-1" role="dialog">
   
  </div>
    <div class="modal modalPositionEndo" tabindex="-1" role="dialog" [ngStyle]="{ 'display': typeOf === 'upload' ? 'block' : 'none' }">
      <div id="spinner" [hidden]="!loading">
        <div class="spinnerfull">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
        </div>
      </div>
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="top:-1.8vw">
          <div class='tableHeadingSurvey'>
            Upload Excel Sheet
             <p  (click)="closeAddModal()">&times;</p>
         </div>
          <div class="modal-body">
            <div class="uploadExcelEndoDiv" >
              <div (click)="triggerFileInput.click()">
                <img class="ml-5" src="/assets/images/uploadEndo.svg"/>
                <p class="text-primary">Browse and upload the excel </p>
              </div>
              <p>click below sample file for reference</p>
              <p> <img class="mr-1" src="/assets/images/fileEndo.svg"/><a href="https://static-files-website.s3.ap-south-1.amazonaws.com/rackrates/EndorsementEmployeesSampleapp.xlsx" >EndorsementEmployeesSample.xlsx</a></p>
              <p>{{uploadedFileName}}</p>
            </div>
            <input type="file" #triggerFileInput (change)="onFileChange($event)" (click)="triggerFileInput.value = null" value=""  style="display: none;" accept=".xlsx">
          </div>
          <p *ngIf="this.excelValMessage" class="text-danger text-center" >{{excelValMessage}}</p>
          <div class="buttonsDivAddEndo p-3">
            <button type="button" class="btn btn-primary mr-3" (click)="submitExcelData()" *ngIf="!this.excelValMessage">Submit</button>
            <button type="button" class="btn btn-secondary" (click)="closeAddModal()" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal modalPositionEndo" tabindex="-1" role="dialog" [ngStyle]="{ 'display': deleteModalOpen ? 'block' : 'none' }">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content" style="top:-1.8vw">
          <div class='tableHeadingSurvey'>
            Are you sure you want to delete these lives ?
             <p (click)="closeDeleteModal()">&times;</p>
         </div>
          <div class="modal-body deleteModalEndo">
            <div *ngFor="let deleteCard of this.storeCardsArr; let i=index">
              <div class="row p-1">
                <div class="col-md-5 deleteLabel">Name :</div>
                <div class="col-md-5 deleteModaVal">{{deleteCard.name}}</div>
              </div>
              <div class="row p-1">
                <div class="col-md-5 deleteLabel">Date of resignation:</div>
                <div class="col-md-5 deleteModaVal">
                <input   *ngIf="!toggleForFamDelete[i].toggleDateForSelf" (change)="handleLeavingDate($event,i)"     [disabled]="i > 0 && storeCardsArr[0].relation.toLowerCase() === 'self' && this.storeCardsArr[0].empId===deleteCard.empId" [value]="deleteCard.dor"  max="{{this.maxDate}}" name="dor" class="inputDeleteModal" type="date" (keydown)="disableTyping($event)"/>  
                <input  (focus)="focusDatesForFamDateDelete($event,i)" *ngIf="toggleForFamDelete[i].toggleDateForSelf"  [value]="deleteCard.dor | date: 'MMM d, y'"  type="text"/>  
                </div>
              </div>
              <div class="row p-1">
                <div class="col-md-5 deleteLabel">Date of Birth:</div>
                <div class="col-md-5 deleteModaVal">
                <input *ngIf="!toggleForFamDelete[i].toggleDateForDob" (change)="handleLeavingDate($event,i)"   max="{{this.maxDate}}" [value]="deleteCard.dob" [disabled]="deleteCard.disableDate" name="dob" class="inputDeleteModal" type="date" (keydown)="disableTyping($event)"/>
                <input  (focus)="focusDatesForFamDobDelete($event,i)" *ngIf="toggleForFamDelete[i].toggleDateForDob"  [value]="deleteCard.dob | date: 'MMM d, y'"  type="text"/>  
              </div>
              </div>
              <div class="row p-1">
                <div class="col-md-5 deleteLabel">Endorsement Type:</div>
                <div class="col-md-5 deleteModaVal">Deletion</div>
              </div>
              <div class="row p-1">
                <div class="col-md-5 deleteLabel">Card Number:</div>
                <div class="col-md-5 deleteModaVal">{{deleteCard.cardNo}}</div>
              </div>
              <hr/>
            </div>
          </div>
          <div class="buttonsDivAddEndo p-3">
            <button type="button" class="confirmDeleteEndo mr-3" (click)="proceedDeleteEmp('Deletion')">Proceed</button>
            <button type="button" class="btn btn-secondary" (click)="closeDeleteModal()" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal modalPositionEndo" tabindex="-1" role="dialog" [ngStyle]="{ 'display': editModalOpen ? 'block' : 'none' }">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content" style="top:-1.8vw">
          <div class='tableHeadingSurvey'>
            Edit
             <p (click)="closeEditModal()">&times;</p>
         </div>
          <div class="modal-body deleteModalEndo">
            <div class="row">
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Name <span class="text-danger">*</span></label>
              <input class="inputForAddEmpEndo" (change)="handleChangeEmpEdit($event)" [value]="editObj?.name?editObj?.name:''" name="name" placeholder="Name" type="text"/>  
              </div>
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Employee ID <span class="text-danger">*</span></label>
              <input  class="inputForAddEmpEndo" (change)="handleChangeEmpEdit($event)" [value]="editObj?.empId?editObj?.empId:''" name="empId" placeholder="Employee ID" type="text"/>  
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Date of Birth (DD/MM/YYYY)  <span class="text-danger">*</span></label>
              <input class="inputForAddEmpEndo" *ngIf="!toggleForFamEdit.toggleDateForDob" (change)="handleChangeEmpEdit($event)" [value]="editObj?.dob?editObj?.dob:''" name="dob" type="date" (keydown)="disableTyping($event)"/>  
              <input  class="inputForAddEmpEndo" (focus)="focusDatesForFamDateEdit($event,'toggleDateForDob')" *ngIf="toggleForFamEdit.toggleDateForDob"  [value]="editObj?.dob | date: 'MMM d, y'"  type="text"/>  
              </div>
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Relationship <span class="text-danger">*</span></label>
              <input  class="inputForAddEmpEndo" (change)="handleChangeEmpEdit($event)" [value]="editObj?.relation?editObj?.relation:''" name="relation" placeholder="Relationship" type="text"/>  
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Gender <span class="text-danger">*</span></label>
                <select class="inputForAddEmpEndo"(change)="handleChangeEmpEdit($event)" [value]="editObj?.gender?editObj?.gender:''" name="gender"  placeholder="Gender" type="text">  
                  <option value="" selected disabled>Select Gender</option>
                  <option value="Female">Female</option>
                  <option value="Male">Male</option>
                  <option value="Others">Others</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Sum Insured <span class="text-danger">*</span></label>
              <input  class="inputForAddEmpEndo" (change)="handleChangeEmpEdit($event)" [value]="editObj?.sumInsured?editObj?.sumInsured:''" name="sumInsured" placeholder="Sum Insured" type="text"/>  
              </div>                         
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Date of Joining (DD/MM/YYYY)  <span class="text-danger">*</span></label>
              <input class="inputForAddEmpEndo"  *ngIf="!toggleForFamEdit.toggleDateForDoj"  (change)="handleChangeEmpEdit($event)" [value]="editObj?.doj?editObj?.doj:''" name="doj" placeholder="Name" type="date" (keydown)="disableTyping($event)"/>  
              <input  class="inputForAddEmpEndo" (focus)="focusDatesForFamDateEdit($event,'toggleDateForDoj')" *ngIf="toggleForFamEdit.toggleDateForDoj"  [value]="editObj?.doj | date: 'MMM d, y'"  type="text"/>  
              </div>
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Mobile Number  <span class="text-danger">*</span></label>
              <input  class="inputForAddEmpEndo" (keydown)="onKeyDownMobile($event)" (change)="handleChangeEmpEdit($event)" maxlength="10" [value]="editObj?.mobile?editObj?.mobile:''" name="mobile" placeholder="Mobile Number" type="text"/>  
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Email<span class="text-danger">*</span></label>
              <input  class="inputForAddEmpEndo" (change)="handleChangeEmpEdit($event)" [value]="editObj?.email?editObj?.email:''" name="email" placeholder="Email" type="text"/>  
              </div>
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Endorsement Type <span class="text-danger">*</span></label>
                <input class="inputForAddEmpEndo"  (change)="handleChangeEmpEdit($event)" disabled value="Addition" name="actionType"/>
              </div>
            </div>
            <!-- <div class="row" *ngIf="this.editObj==='Deletion'">
              <div class="col-md-6">
                <label class="inputLabelsAddEndo">Card Number (For deletion cases only)<span class="text-danger">*</span></label>
              <input  class="inputForAddEmpEndo" (change)="handleChangeEmpEdit($event)" [value]="editObj?.cardNo?editObj?.cardNo:''" name="cardNo" placeholder="Card No." type="text"/>  
              </div>
            </div> -->
          </div>
          <p class="text-danger text-center" *ngIf="this.editModalErrorMessage">{{this.editModalErrorMessage}}</p>
          <div class="buttonsDivAddEndo p-3">
            <button type="button" class="confirmDeleteEndo mr-3" (click)="editModalModalAlert()">Submit</button>
            <button type="button" class="btn btn-secondary" (click)="closeEditModal()" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': editModalBool ? 'block' : 'none' }">
      <div class="modal-dialog modal-md" style="min-width: 30%;top:10%" role="document">
        <div class="modal-content">
          <div class='tableHeadingSurvey'>
            Alert
              <p (click)="closeEditModalAlert()">&times;</p>
          </div>
          <div class="modal-body deleteModalEndo">
           Are you sure you want to edit details?
          </div>
          <div class="modalButtonsEndo p-2">
            <button *ngIf="this.typeOfForBtns==='add'" class="btn btn-primary mr-1" (click)="editEmployees()">Yes</button>
            <button *ngIf="this.typeOfForBtns==='edit'" class="btn btn-primary mr-1" (click)="updateEmployees()">Yes</button>
            <button  class="btn btn-danger"(click)="closeEditModalAlert()">No</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': deleteModalProceedOpen ? 'block' : 'none' }">
      <div class="modal-dialog modal-lg" style="min-width: 95%;"  role="document">
        <div class="modal-content" style="top:-1.8vw">
          <div class='tableHeadingSurvey'>
            Calculate Premium
             <div>
              <p (click)="closeProceedDeleteModal()">&times;</p>
              <p *ngIf="this.typeOfForBtns==='add'" class="sumInsuredForAddEndo">Total Premium : {{this.sumInsuredCalc}}</p>
             </div>
         </div>
          <div class="modal-body deleteModalEndo">
            <table class="viewEndoTable table" >
              <thead>
                <tr >
                  <!-- <th>Sr No.</th> -->
                  <th>Name</th>
                  <th>Policy No.</th>
                  <th>Prorated Premium</th>
                  <th>Mobile</th>
                  <th>Employee ID.</th>
                  <th>Endorsement Type</th>
                  <!-- <th>DOB</th> -->
                  <th>Relationship</th>
                  <!-- <th>Gender</th> -->
                  <th>Sum Insured</th>
                  <!-- <th>Date Of Joining</th> -->
                  <!-- <th>Date Of Resignation</th> -->
                  <!-- <th>Policy End Date</th> -->
                  <!-- <th>No. Of Days</th> -->
                  <!-- <th>Age</th> -->
                  <th>Email</th>
                </tr>
              </thead>
              <tbody style="position: relative;margin-top: -6px;" *ngFor="let card of this.proRatePremiumArray; let i=index">
                <tr 
                >
                <!-- <td>{{i + 1}}</td> -->
                <td>{{card.firstName}}</td>
                <td>{{card.policyNumber}}</td>
                <td>{{card.calculation}}</td>
                <td>{{card.mobile}}</td>
                <td>{{card.employeeNumber}}</td>
                <td>{{card.additionOrDeletion}}</td>
                <!-- <td>{{card.dateOfBirth.split("T")[0]}}</td> -->
                <td>{{card.relationshipType}}</td>
                <!-- <td>{{card.gender}}</td> -->
                <td>{{card.sumInsured}}</td>
                <!-- <td>{{ card.dateOfJoining | date: 'yyyy-MM-dd' || '...' }}</td> -->
                <!-- <td>{{ card.dateOfResignation | date: 'yyyy-MM-dd' || '...' }}</td>                 -->
                <!-- <td>{{card.policyEndDate}}</td> -->
                <!-- <td>{{card.numberOfDays}}</td> -->
                <!-- <td>{{card.age}}</td> -->
                <td>{{card.email}}</td>
                </tr>
              </tbody>
              <td class="p-3" colspan="10" *ngIf="this.proRatePremiumArray.length==0">No data availble in table</td>
            </table>
          </div>
          <div class="buttonsDivAddEndo p-3">
            <button type="button" *ngIf="this.typeOfForBtns==='delete'" class="confirmDeleteEndo mr-3" (click)="confirmDeleteEndo('Deletion')">Confirm Delete</button>
            <button type="button" *ngIf="this.typeOfForBtns==='add'" class="confirmDeleteEndo mr-3" (click)="confirmDeleteEndo('Addition')">Submit</button>
            <button type="button" *ngIf="this.typeOfForBtns==='edit'" class="confirmDeleteEndo mr-3" (click)="confirmUpdateEndo()">Confirm Updation</button>
            <button type="button" class="btn btn-secondary" (click)="closeProceedDeleteModal()" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>


    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': endorsementBatchModal ? 'block' : 'none' }">
      <div class="modal-dialog modal-lg" style="min-width: 55%;" role="document">
        <div class="modal-content" style="top:-1.8vw">
          <div class='tableHeadingSurvey'>
            Endorsement Batches
             <p (click)="closeEndoresementBatchModal()">&times;</p>
         </div>
          <div class="modal-body deleteModalEndo">
            <table class="viewEndoTable table" >
              <thead>
                <tr >
                  <th>Sr No</th>
                  <th>Batch Creation Date</th>
                  <th>Batch Id</th>
                  <th>Batch Status</th>
                  <th>Batch Type</th>
                  <th>Batch Source</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style="position: relative;margin-top: -6px;" *ngFor="let card of this.endoBatchesArr; let i=index">
                <tr>
                <td>{{i+1}}</td>
                <td>{{card.batchCreationDate | date: 'dd/MM/yyyy' || '...' }}</td>
                <td>{{card.batchId}}</td>
                <td>{{card.batchStatus}}</td>
                <td *ngIf="card.batchType==='updation'">Updation</td>
                <td *ngIf="card.batchType!='updation'">Addition/Deletion</td>
                <td>{{card.batchSource || '--'}}</td>
                <td class="row" style="width: 310px;">
                  <button  class="viewBatchEndoBtns"  *ngIf="card.batchType!=='updation'" (click)="viewBatchDetailsByBatchId(card.batchId)"><img src="/assets/images/eyeEndo.svg" width="15px" class="mr-1"/>Batch Details</button> 
                  <button class="viewBatchEndoBtns"  (click)="viewEmployeeByBatchId(card.batchId,card.batchType)"><img src="/assets/images/eyeEndo.svg" width="15px" class="mr-1"/>Employee Details</button></td>
              </tbody>
              <!-- <td class="p-3" colspan="10" *ngIf="this.endoBatchesArr.length==0">No data availble in table</td> -->
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': batchDetailsFromBatchIdModal ? 'block' : 'none' }">
      <div class="modal-dialog modal-md" style="min-width: 56%;" role="document">
        <div class="modal-content" style="top:-1.8vw">
          <div class='tableHeadingSurvey'>
            Batch Details
             <p (click)="closeEndoresementBatchDetailsModal()">&times;</p>
         </div>
          <div class="modal-body deleteModalEndo" style="min-height: 400px;">
            <table class="viewEndoTable table" >
              <thead class="stickTableEndoHead">
                <tr >
                  <th>Batch Premium</th>
                  <th>Approved Amount</th>
                  <th>Endorsement Number</th>
                </tr>
              </thead>
              <tbody style="position: relative;margin-top: -6px;" >
                <tr>
                <td>{{this.batchDetailsFromBatchObj.batchPremium}}</td>
                <td>{{this.batchDetailsFromBatchObj.approvedAmount || 'NA'}}</td>
                <td>{{this.batchDetailsFromBatchObj.endorsementPolicyNumber || 'NA'}}</td>
              </tbody>
              <!-- <td class="p-3" colspan="10" *ngIf="this.endoBatchesArr.length==0">No data availble in table</td> -->
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': employeesByBatchIdModal ? 'block' : 'none' }">
      <div class="modal-dialog modal-lg" style="min-width: 70%;" role="document">
        <div class="modal-content" style="top:-1.8vw">
          <div class='tableHeadingSurvey'>
            Batch Employee Details
             <p (click)="closeEndoresementEmployeeBatchModal()">&times;</p>
         </div>
          <div class="modal-body deleteModalEndo" style="min-height: 400px;">
            <table class="viewEndoTable table" >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Endorsement Type</th>
                  <th>Employee ID</th>
                  <th>DOB</th>
                  <th>Relationship</th>
                  <th>Gender</th>
                  <th>Sum Insured</th>
                  <th>Date of Joining</th>
                  <th>Date Of Resignation</th>
                  <th>Mobile Number</th>
                  <th>Email Id</th>
                </tr>
              </thead>
              <tbody style="position: relative;margin-top: -6px;" *ngFor="let card of this.employeeByBatchArr; let i=index">
                <tr *ngIf="card.endorsementType==='Addition'||card.endorsementType==='Deletion'">
                  <td>{{card.insuredName}}</td>
                  <td>{{card.endorsementType}}</td>
                  <td>{{card.employeeNumber}}</td>
                  <td>{{card.dateOfBirth | date: 'dd/MM/yyyy' || '...' }}</td>
                  <td>{{card.relationshipType}}</td>
                  <td>{{card.gender}}</td>
                  <td>{{card.sumInsured}}</td>
                  <td>{{card.dateOfJoining | date: 'dd/MM/yyyy' || '...' }}</td>
                  <td>{{card.dateOfResignation | date: 'dd/MM/yyyy' || '...' }}</td>
                  <td>{{card.mobile}}</td>
                  <td>{{card.email}}</td>
                </tr>
                <tr *ngIf="card.endorsementType!=='Addition'&&card.endorsementType!=='Deletion'">
                  <td>{{card.name}}</td>
                  <td>Updation</td>
                  <td>{{card.empId}}</td>
                  <td>{{card.dob}}</td>
                  <td>{{card.relation}}</td>
                  <td>{{card.gender}}</td>
                  <td>{{card.sumInsured}}</td>
                  <td >{{card.doj}}</td>
                  <td>{{card.dor}}</td>
                  <td>{{card.mobile}}</td>
                  <td>{{card.email}}</td>
                </tr>
              </tbody>
              <!-- <td class="p-3" colspan="10" *ngIf="this.employeeByBatchArr.length==0">No data availble in table</td> -->
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': updateEmployeeModal ? 'block' : 'none' }">
      <div class="modal-dialog modal-lg" style="min-width: 80%;" role="document">
        <div class="modal-content" style="top:-1.8vw">
          <div class='tableHeadingSurvey'>
            Update Employee Details
             <p (click)="closeUpdateModal()">&times;</p>
         </div>
          <div class="modal-body deleteModalEndo">
          <p class="text-danger text-left h6" style="font-size: 13px;" >The endorsement team will update the records, ensuring changes are reflected universally.</p>
          <p class="text-success text-right fw-bold" *ngIf="updateSuccessMessage">{{updateSuccessMessage}}</p>
          <p class="text-danger text-right fw-bold" style="font-size: 13px;"*ngIf="uploadErrorMessage">{{uploadErrorMessage}}</p>
            <table class="viewEndoTable table">
              <thead class="stickTableEndoHead">
                <tr >
                  <th>Name</th>
                  <th>Mobile Number</th>
                  <th>Employee Id</th>
                  <!-- <th>Age</th> -->
                  <th>Relationship</th>
                  <th>Email Id</th>
                  <th *ngIf="fileUploadBool">Document Type</th>
                  <th *ngIf="fileUploadBool">Upload Document  <em title="Pdf, jpg,jpeg, png file format are allowed" class="toolTipForEndo">i</em></th>
                  <!-- <th>Date Of Joining</th> -->
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style="position: relative;margin-top: -6px;" *ngFor="let card of this.storeCardsArr; let i=index">
                <tr 
                >
                  <td><input class="inputForUpdateEmpEndo" (change)="handleUpdatedValues($event,i)" name="name" type="text" [value]="card.name"/></td>
                  <td><input class="inputForUpdateEmpEndo" (change)="handleUpdatedValues($event,i)" name="mobile" type="text" [value]="card.mobile"/></td>
                  <td><input class="inputForUpdateEmpEndo" (change)="handleUpdatedValues($event,i)" name="empId" type="text" [value]="card.empId"/></td>
                  <!-- <td><input class="inputForUpdateEmpEndo" (change)="handleUpdatedValues($event,i)" name="age" type="text" [value]="card.age"/></td> -->
                  <td><input class="inputForUpdateEmpEndo" (change)="handleUpdatedValues($event,i)" name="relation" type="text" [value]="card.relation"/></td>
                  <td><input class="inputForUpdateEmpEndo" (change)="handleUpdatedValues($event,i)" name="email" type="text" [value]="card.email"/></td>
                  <td *ngIf="fileUploadBool">
                    <select class="inputForUpdateEmpEndo" (change)="handleUpdatedValues($event,i)" name="documentType" [value]="card.documentType||''">
                    <option selected value="">Select Document</option>
                    <option value="Aadhar Card">Aadhar Card</option>
                    <option value="PAN Card">PAN Card</option>
                    <option value="Driving License">Driving License</option>
                    <option value="Voter id">Voter id</option>
                    <option value="Others">Others</option>
                  </select>
                  </td>
                  <td *ngIf="fileUploadBool" (change)="saveIdentityFile($event)"><input type="file"/></td>
                  <!-- <td><input class="inputForUpdateEmpEndo" (change)="handleUpdatedValues($event,i)" name="doj" type="date"  max="{{this.maxDate}}" [value]="card.doj | date: 'yyyy-MM-dd' "/></td> -->
                  <td style="width: 150px;">
                    <button (click)="openConfirmModalUpdate(i)" class="viewBatchEndoBtns mt-1" style="color:#5046e5">
                      <img src="/assets/images/saveEndo.svg" class="mr-1" alt="saveEndo"/>Save
                    </button>
                  </td>
                </tr>
              </tbody>
              <!-- <td class="p-3" colspan="10" *ngIf="this.employeeByBatchArr.length==0">No data availble in table</td> -->
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': updateModalBool ? 'block' : 'none' }">
      <div class="modal-dialog modal-md" style="min-width: 30%;top:8%" role="document">
        <div class="modal-content">
          <div class='tableHeadingSurvey'>
            Alert
              <p (click)="closeConfirmUpdateModal()">&times;</p>
          </div>
          <div class="modal-body deleteModalEndo">
            Are you Sure you want to update the Employee details
          </div>
          <div class="modalButtonsEndo p-2">
            <button class="btn btn-primary mr-1" (click)="updateEmployees()">Yes</button>
            <button  class="btn btn-danger"(click)="closeConfirmUpdateModal()">No</button>
          </div>
        </div>
      </div>
    </div>
    
 <div class="row">
   <div class="col-md-5 col-lg-1">
     <img src="/assets/images/endorsementLogo.svg" alt="endorsmentLogo"/>
    </div>
    <div class="col-md-5 col-lg-8 d-flex justify-content-center" style="height: 36px;">
      <button  [ngClass]="typeOfForBtns=='view' || typeOf=='edit' || typeOf=='delete' ? 'activeECardBtn mr-4' : 'InactiveBtns mr-4'" (click)="buttonsSectionFucn('view')" >Active eCards</button>
      <!-- <div class="row" *ngIf="!inProgressBtnFlag">
        <button class="InactiveBtns inProgressBtn"  (click)="inProgressButtonCall()">Calculation E-cards</button>
      </div> -->
      <div class="row" *ngIf="isManagerialLogin">
      <button [ngClass]="typeOfForBtns=='add' ? 'activeECardBtn mr-1' : 'InactiveBtns mr-1'" (click)="buttonsSectionFucn('add')" >Addition Calculation <em title="Employee details added, pending for premium verification by you" class="toolTipForEndo">i</em></button>
      <button [ngClass]="typeOfForBtns=='delete' ? 'activeECardBtn mr-1' : 'InactiveBtns mr-1'" (click)="buttonsSectionFucn('delete')" >Deletion Calculation<em title="Employee deleted, pending for premium verification by you" class="toolTipForEndo">i</em></button>
      <button [ngClass]="typeOfForBtns=='edit' ? 'activeECardBtn mr-1' : 'InactiveBtns mr-1'"  (click)="buttonsSectionFucn('edit')" >Updation <em title="Changes initiated by you but pending for Final submission." class="toolTipForEndo">i</em></button>
    </div>
    <button class="previousEndoBatchBtn ml-4"  (click)="endorsementBatches()">Endorsement Batches</button>
  </div>
  <div class="col-md-2 col-lg-3 text-right" *ngIf="isManagerialLogin">
    <button class="addEmployeeBtn" (click)="addEmployeeModalOpen()">+ Add Employee/Dependent</button>
  </div>
 </div>
 <hr/>
 <div class="container">
  <div class="row">
    <div class="col-md-10 mt-2">
    <div class="row">
      <input type="text" placeholder="Search" (input)="globalSearchFilter($event.target.value)" [value]="searchVal"  class="viewEndoSearch mr-1"/>
      <button class="cdBtns mr-1">CD Balance : <strong>₹ {{this.cdBalance}}</strong></button>
      <button class="cdBtns">Hold Balance : <strong>₹ {{this.holdCdBalance}}</strong></button>
    </div>
    </div>
    <div class="col-md-2 mx-auto mt-3" *ngIf="isManagerialLogin">
     <div class="row" *ngIf="this.typeOfForBtns=='view' || this.typeOfForBtns=='add'">
      <img src="/assets/images/uploadExcelEndo.svg" /> <p class="updateDeleteBtnEndo mt-1 ml-1" (click)="openUploadExcelBtn()">Upload Excel Sheet</p>
    </div>
    </div>
  </div>
 </div>
 <div class="mt-4 activeECardsEndo" [class.blurBackClass]="blurBackGround">
  <div class="container" style="max-width: fit-content;">
    <div class="">
      <div class="">
        <div class="d-flex">
          <h3 class="activeEcardsHeader" *ngIf="this.headerType!=='Addition Calculation'">{{this.headerType}} <span class="activeEcardsCount">{{this.activeCardArr.length}}</span></h3>
          <div class="additonInProgressDiv mb-3" *ngIf="this.headerType==='Addition Calculation'">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button  [ngClass]="{'additionInProgressBtnDisable': formType==='addForm', 'additionInProgressBtnEnable': formType==='add'}" (click)="additionInProgressAgain()" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Addition Calculation <span class="activeEcardsCount">{{this.activeCardArr.length}}</span></button>
              </li>
              <li class="nav-item" role="presentation">
                <button [ngClass]="{'additionInProgressBtnDisable': formType==='add', 'additionInProgressBtnEnable': formType==='addForm'}" (click)="addEmployeeModalOpen()" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="true"> + Add Employee / Dependent</button>
              </li>
            </ul>
          <p class="mt-2 ml-2" style="font-size: 15px;" *ngIf="formType==='add'">Please click 'Calculate Premium' to confirm Addition of selected employees.
          </div>
          <p class="mt-2 ml-2" style="font-size: 15px;" *ngIf="headerType==='Deletion Calculation'">Please click 'Calculate Premium' to confirm deletion of selected employees.
          </p>
          <p class="mt-2 ml-2" style="font-size: 15px;" *ngIf="headerType==='Updation'">Please click 'Confirm Updation' to Update the selected employees.
          </p>
        </div>
        <div style="max-height: 475px;overflow-y: auto;" *ngIf="formType==='add' || headerType==='Active eCards' || headerType==='Deletion Calculation' ||  headerType==='Updation'">
          <table class="viewEndoTable table">
            <thead class="stickTableEndoHead">
              <tr >
                <ng-container *ngIf="isManagerialLogin"><th><input type="checkbox"  [(ngModel)]="selectAll" (change)="selectEveryRow()" /></th></ng-container>
                <th style="min-width: 110px;">Name</th>
                <th>Emp ID</th>
                <th *ngIf="this.typeOfForBtns!='add'">Card No</th>
                <th *ngIf="this.typeOfForBtns=='add'">Status</th>
                <th  style="min-width: 80px;">Mobile Number</th>
                <th>Age</th>
                <th>Gender</th>
                <th style="min-width: 80px;">Relation</th>
                <th>Sum Insured</th>
                <th>Email</th>
                <th>DOJ</th>
                <!-- <th *ngIf="this.typeOfForBtns!='edit'">Created Date</th> -->
                <th *ngIf="this.typeOfForBtns=='edit'">Update Request Date</th>
                <!-- <th *ngIf="this.typeOfForBtns!='edit'">Created Time</th> -->
                <th *ngIf="this.typeOfForBtns=='edit'">Update Request Time</th>
                <th>User Type</th>
                <ng-contaier *ngIf="!isManagerialLogin && isClinetNFI">
                  <th style="min-width: 80px;">CSO Name</th>                                                                
                  <th style="min-width: 80px;">CSO Mobile</th>
                  <th style="min-width: 80px;">CSO Email</th>
                </ng-contaier> 
                <span *ngIf="this.familyDefinitionFlag !== 'Self'"><ng-container *ngIf="isManagerialLogin"><th *ngIf="this.typeOfForBtns=='view'" style="min-width: 110px;">Add Dependents</th></ng-container></span>
                <ng-container *ngIf="isManagerialLogin"><th *ngIf="this.typeOfForBtns=='view'">Download E-card</th></ng-container>
                <!-- <th *ngIf="this.typeOfForBtns!='add'">Ticket No</th> -->
                <!-- <th>Action</th> -->
              </tr>
            </thead>
            <tbody style="position: relative;margin-top: -6px;" *ngFor="let card of this.activeCardArr; let i=index">
              <tr [ngStyle]="{ 'background-color': card.bgColor }" 
              (mouseenter)="onMouseEnter(i)"
              (mouseleave)="onMouseLeave(i)"
              [title]="typeOfForBtns === 'view' ? (card.isDeletionPending ? 'This record is already included in the deletion calculation.' : (card.isUpdationPending ? 'This record is already included in the updation calculation.' : '')) : ''"
              >
              <ng-container *ngIf="isManagerialLogin">
                <td> 
                  <span *ngIf="headerType !== 'Active eCards' || (!card.isDeletionPending && !card.isUpdationPending)">
                    <input type="checkbox" *ngIf="card.cardNo==='Endorsement-Not-Initaited' || card.cardNo!='Endorsement-Pending'" [disabled]="this.typeOfForBtns=='view' &&(card.isDeletionPending||card.isUpdationPending)" [checked]="card.isChecked"  (change)="clickonRow(card)" class="endoCheckBox"  />
                  </span>
                  <span *ngIf="headerType === 'Active eCards' && !!card.isDeletionPending">
                    In deletion queue
                  </span>
                  <span *ngIf="headerType === 'Active eCards' && !!card.isUpdationPending">
                    In updation queue
                  </span>
                </td>
              </ng-container>
                <td>{{card.name}}</td>
                <td>{{card.empId}}</td>
                <td>{{card.cardNo}}</td>
                <td>{{card.mobile}}</td>
                <td>{{card.age}}</td>
                <td>{{card.gender}}</td>
                <td>{{card.relation}}</td>
                <td>{{card.sumInsured}}</td>
                <td >{{card.email}}</td>
                 <td>{{ card.doj | date: 'dd/MM/yyyy' || '...' }}</td>
                <!-- <td>{{card.dateCreated}}</td> -->
                <!-- <td>{{card.timeCreated}}</td> -->
                <td>{{card.uploadType}}</td>
                <ng-contaier *ngIf="!isManagerialLogin && isClinetNFI">
                  <td>{{card.csoName}}</td>
                  <td>{{card.csoMobile}}</td>
                  <td>{{card.csoEmail}}</td>
                </ng-contaier>
                <span *ngIf="this.familyDefinitionFlag !== 'Self'"><ng-container *ngIf="isManagerialLogin"><td *ngIf="this.typeOfForBtns=='view'"><span *ngIf="headerType !== 'Active eCards' || (!card.isDeletionPending && !card.isUpdationPending)"><p (click)="addDependentsFromActiveCard(card)" class="addDependentsBtn"><span *ngIf="card.relation ==='SELF'">Add +</span></p></span></td></ng-container></span> 
                <ng-container *ngIf="isManagerialLogin"><td *ngIf="this.typeOfForBtns=='view'"><span *ngIf="headerType !== 'Active eCards' || (!card.isDeletionPending && !card.isUpdationPending)"><p (click)="DownloadEcard(card, i)" class="addDependentsBtn">Download</p></span></td></ng-container>
                <!-- <td *ngIf="this.typeOfForBtns!='add'">{{card.ticketNo}}</td> -->
                <!-- <td (click)="openPreview(i)" style="cursor: pointer"> <img src="/assets/images/eyeEndo.svg" width="15px" class="mr-1"/>View </td> -->
              </tr>
            </tbody>
            <td class="p-3" colspan="10" *ngIf="this.activeCardArr.length==0">No data availble in table</td>
          </table>
        </div>
        <ng-container *ngIf="isManagerialLogin">
          <div class="row fixedBtnDivEndo ml-1 mt-1" *ngIf="this.typeOfForBtns=='view' && this.activeCardArr.length!==0 ">
          <button class="floaterBtnsEndo mt-1 ml-1" (click)="bulkDelete()">  <img src="/assets/images/deleteEndo.svg"  class=" mr-1"/>Delete</button>
          <button  class="floaterBtnsEndoUpdate mt-1 ml-1" (click)="updateEmployee()"><img src="/assets/images/updateEmpEndo.svg"/>   Update Employee</button>
        </div>
      </ng-container>
        <div class="row fixedBtnDivEndo ml-1 mt-1" *ngIf="this.typeOfForBtns=='add' && this.activeCardArr.length!==0 && formType!='addForm'">
          <button  class="floaterBtnsEndoCalcPrem mt-1 ml-1" (click)="previewCalculatedPremium('Addition')"><img src="/assets/images/calcPremEndo.svg" class=" mr-1"/>Calculate Premium</button>
          <button  class="floaterBtnsEndoUpdate mt-1 ml-1" (click)="editModalOpenFunc('')"><img src="/assets/images/updateEmpEndo.svg"/>Edit</button>
        </div>
        <div class="row fixedBtnDivEndo ml-1 mt-1" *ngIf="this.typeOfForBtns=='edit'">
          <button  class="floaterBtnsEndoCalcPrem mt-1 ml-1" (click)="calculatePremForUpdate()">Confirm Updation</button>
          <button  class="floaterBtnsEndoUpdate mt-1 ml-1" (click)="updateEmployee()"><img src="/assets/images/updateEmpEndo.svg"/>Edit</button>
        </div>

        <div class="row fixedBtnDivEndo ml-1 mt-1" *ngIf="this.typeOfForBtns=='delete'">
          <button  class="floaterBtnsEndoCalcPrem mt-1 ml-1" (click)="previewCalculatedPremium('Deletion')"><img src="/assets/images/calcPremEndo.svg" class=" mr-1"/>Calculate Premium</button>
        </div>
      </div>
    
      <div class="accordion" id="accordionExample" *ngIf="formType==='addForm' && headerType==='Addition Calculation'">
        <div  *ngIf="goFromActiveCardsForSelf" [ngClass]="{'dottedCardEndo': saveAndReviewBool, 'card': !saveAndReviewBool}">
          <div class="p-3 headerDivEndo text-left accordionHeaders mb-0" id="headingOne" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" (click)="toggleCollapse()">
            <h2 class="accordionHeaders font-weight-bold mb-0">
                Add Self Details <img *ngIf="saveAndReviewBool" src="/assets/images/checkedEndo.svg" width="25px" style="margin-bottom: 6px;"/> 
            </h2>
            <p>
                <img  data-toggle="collapse" aria-controls="collapseOne" data-target="#collapseOne" *ngIf="!isCollapsed" src="/assets/images/accordionIconEndo1.svg"/>
                <img  data-toggle="collapse" aria-controls="collapseOne" data-target="#collapseOne" *ngIf="isCollapsed" src="/assets/images/accordionIconEndo2.svg"/>
            </p>            
        </div>        
        
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="">
            <div>
            <div class="card-body">
              <div>
                  <!-- <hr/> -->
                    <div class="row">
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Name <span class="text-danger">*</span></label>
                      <input class="inputForAddEmpEndo" (change)="handleChangeEmp($event)" [value]="empObj.name" name="name" placeholder="Name" type="text"/>  
                      </div>
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Employee ID <span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo" (change)="handleChangeEmp($event)" [value]="empObj.empId" name="empId" placeholder="Employee Id" type="text"/>  
                      </div>
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Endorsement Type <span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo" (change)="handleChangeEmp($event)" [value]="empObj.actionType" disabled name="actionType" placeholder="Endorsement Type" type="actionType"/>  
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Date of Birth<span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo" *ngIf="!toggleDateForSelf" (change)="handleChangeEmp($event)" max="{{this.maxDate}}"  [value]="empObj.dob" name="dob" type="date" (keydown)="disableTyping($event)"/>  
                      <input  class="inputForAddEmpEndo" (focus)="focusDatesForDate($event,'dob')" *ngIf="toggleDateForSelf"  [value]="empObj.dob | date: 'MMM d, y'"  type="text"/>  
                      </div>
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Relationship <span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo"disabled (change)="handleChangeEmp($event)" value="Self" name="relation"> 
                      </div>
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Gender <span class="text-danger">*</span></label>
                      <select class="inputForAddEmpEndo"(change)="handleChangeEmp($event)" [value]="empObj.gender" name="gender"  placeholder="Gender" type="text">  
                        <option value="" selected disabled>Select Gender</option>
                        <option value="Female">Female</option>
                        <option value="Male">Male</option>
                        <option value="Others">Others</option>
                      </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Sum Insured <span class="text-danger">*</span></label>
                      <input class="inputForAddEmpEndo sumInsuredInpClass" (keydown)="onKeyDown($event)"  (change)="handleChangeEmp($event)" [value]="empObj.sumInsured" name="sumInsured" placeholder="Sum Insured" type="number"/>  
                      </div>
                      <div class="col-md-4" *ngIf="empObj?.actionType==='Addition'">
                        <label class="inputLabelsAddEndo">Date of Joining <span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo"  *ngIf="!toggleDoj" (change)="handleChangeEmp($event,'doj')"   max="9999-12-31"  [value]="empObj.doj" name="doj" type="date" (keydown)="disableTyping($event)"/>  
                      <input  class="inputForAddEmpEndo" (focus)="focusDatesForDoj($event,'doj')" *ngIf="toggleDoj"  [value]="empObj.doj | date: 'MMM d, y'"  type="text"/>  
                      </div>
                      <!-- <div class="col-md-4"  *ngIf="empObj?.actionType==='Deletion'">
                        <label class="inputLabelsAddEndo">Date of Resignation (DD/MM/YYYY) <span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo"  (change)="handleChangeEmp($event)" max="9999-12-31" [value]="empObj.dateOfResignation" name="dateOfResignation" type="date"/>  
                      </div> -->
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Mobile Number <span class="text-danger">*</span></label>
                      <input class="inputForAddEmpEndo"  (change)="handleChangeEmp($event)" [value]="empObj.mobile" maxlength="10" (keydown)="onKeyDownMobile($event)"  name="mobile"placeholder="Mobile Number" type="text"/>  
                      </div>
                    </div>
                    <div class="row">
                     
                      <div class="col-md-4">
                        <label class="inputLabelsAddEndo">Email <span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo" (change)="handleChangeEmp($event)"[value]="empObj.email"  name="email" placeholder="Email" type="text"/>  
                      </div>
                      <!-- <div class="col-md-4"  *ngIf="empObj?.actionType==='Deletion'">
                        <label class="inputLabelsAddEndo">Card Number (For deletion cases only)</label>
                      <input class="inputForAddEmpEndo" (change)="handleChangeEmp($event)" [value]="empObj.cardNo" name="cardNo" placeholder="Card Number (For deletion cases only)" type="text"/>  
                      </div> -->
                    </div>
                  </div>
                  </div>
                  </div>
          </div>
        </div>
        <div *ngIf="goFromActiveCardsForFamily"  [ngClass]="{'dottedCardEndo': saveAndReviewBool, 'card': !saveAndReviewBool}">
          <div class="p-3 headerDivEndo text-left accordionHeaders mb-0" (click)="clickOnFamilyDetails()" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
            <h2 class="accordionHeaders font-weight-bold mb-0">
                Add Family Details <img *ngIf="saveAndReviewBool" src="/assets/images/checkedEndo.svg" width="25px" style="margin-bottom: 6px;"/> 
              </h2>
              <p>
                <img  type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo" *ngIf="isCollapsed2" src="/assets/images/accordionIconEndo1.svg"/>
                <img  type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo" *ngIf="!isCollapsed2" src="/assets/images/accordionIconEndo2.svg"/>
              </p>  
          </div>
          <div id="collapseTwo" [ngClass]="{'collapse': !goFromActiveCardsForFamily, 'collapse show': goFromActiveCardsForFamily}" aria-labelledby="headingTwo" data-parent="">
            <div class="card-body">
              <div class="selectFamDivEndo" *ngIf="familyDefinitionFlag !== 'Self'">
                <p>Select Family Members</p>
                <p>Please select and click/check by clicking on family member checkbox</p>
              </div>
              <div class="selectFamDivEndo" *ngIf="familyDefinitionFlag === 'Self'">
                <p>Family definition for this policy is Self.</p>
                <p>You cannot add family members details for this policy. </p>
              </div>
              <div class="mt-3">
                <ng-container *ngIf="familyDefinitionFlag !== 'Self'">
                  <ng-container *ngIf="familyDefinitionFlag === 'Self + Spouse + Kids' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents' || familyDefinitionFlag === 'Self + Spouse + Kids + In laws (Mother/Father)' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents/Parent In Laws' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents + Parent In Laws' || familyDefinitionFlag === 'all'">
                    <button  [ngClass]="{'selectFamDivEndoBtn': !familyDefitionArr.includes('Child1'), 'selectFamDivEndoBtnInserted': familyDefitionArr.includes('Child1')}" (click)="SelectFamilyDefintion('Child1')"> 
                      <img *ngIf="familyDefitionArr.includes('Child1')" src="/assets/images/checkedEndo.svg" class="mr-1" width="18px"/>Child1 </button>
                    <button  [ngClass]="{'selectFamDivEndoBtn': !familyDefitionArr.includes('Child2'), 'selectFamDivEndoBtnInserted': familyDefitionArr.includes('Child2')}" (click)="SelectFamilyDefintion('Child2')">
                      <img *ngIf="familyDefitionArr.includes('Child2')" src="/assets/images/checkedEndo.svg" width="18px"/> Child2</button>
                    <button  [ngClass]="{'selectFamDivEndoBtn': !familyDefitionArr.includes('Child3'), 'selectFamDivEndoBtnInserted': familyDefitionArr.includes('Child3')}" (click)="SelectFamilyDefintion('Child3')">
                      <img *ngIf="familyDefitionArr.includes('Child3')" src="/assets/images/checkedEndo.svg" width="18px"/> Child3</button>
                  </ng-container>
                  <ng-container *ngIf="familyDefinitionFlag === 'Self + Spouse' || familyDefinitionFlag === 'Self + Spouse + Kids' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents' || familyDefinitionFlag === 'Self + Spouse + Kids + In laws (Mother/Father)' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents/Parent In Laws' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents + Parent In Laws' || familyDefinitionFlag === 'all'">
                    <button  [ngClass]="{'selectFamDivEndoBtn': !familyDefitionArr.includes('Spouse'), 'selectFamDivEndoBtnInserted': familyDefitionArr.includes('Spouse')}" (click)="SelectFamilyDefintion('Spouse')">
                      <img *ngIf="familyDefitionArr.includes('Spouse')" src="/assets/images/checkedEndo.svg" width="18px"/> Spouse</button>
                  </ng-container>
                  <ng-container *ngIf="isParentVisible && (familyDefinitionFlag === 'Self + Spouse + Kids + Parents' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents/Parent In Laws' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents + Parent In Laws' || familyDefinitionFlag === '2 Parents' || familyDefinitionFlag === '2 Parents/Parent In Laws' || familyDefinitionFlag === 'Self + 2 Parents' || familyDefinitionFlag === 'Self + 2 Parents/Parent In Laws' || familyDefinitionFlag === 'all')">
                    <button [attr.title]="!goFromActiveCardsForSelf ? infoMessage : ''" [attr.disabled]="!goFromActiveCardsForSelf ? true : null" [ngClass]="{'selectFamDivEndoBtn': !familyDefitionArr.includes('Father'), 'selectFamDivEndoBtnInserted': familyDefitionArr.includes('Father'),'disabled-button': !goFromActiveCardsForSelf}" (click)="SelectFamilyDefintion('Father')"> 
                      <img *ngIf="familyDefitionArr.includes('Father')" src="/assets/images/checkedEndo.svg" width="18px"/> Father</button>
                    <button [attr.title]="!goFromActiveCardsForSelf ? infoMessage : ''" [attr.disabled]="!goFromActiveCardsForSelf ? true : null" [ngClass]="{'selectFamDivEndoBtn': !familyDefitionArr.includes('Mother'), 'selectFamDivEndoBtnInserted': familyDefitionArr.includes('Mother'),'disabled-button': !goFromActiveCardsForSelf}" (click)="SelectFamilyDefintion('Mother')">
                      <img *ngIf="familyDefitionArr.includes('Mother')" src="/assets/images/checkedEndo.svg" width="18px"/> Mother</button>
                  </ng-container>
                  <ng-container *ngIf="isInLawParentsVisible && (familyDefinitionFlag === 'Self + Spouse + Kids + In laws (Mother/Father)' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents/Parent In Laws' || familyDefinitionFlag === 'Self + Spouse + Kids + Parents + Parent In Laws' || familyDefinitionFlag === '2 Parents/Parent In Laws' || familyDefinitionFlag === 'Self + 2 Parents/Parent In Laws' || familyDefinitionFlag === 'all')">
                    <button [attr.title]="!goFromActiveCardsForSelf ? infoMessage : ''"  [attr.disabled]="!goFromActiveCardsForSelf ? true : null"  [ngClass]="{'selectFamDivEndoBtn': !familyDefitionArr.includes('Mother In Law'), 'selectFamDivEndoBtnInserted': familyDefitionArr.includes('Mother In Law'),'disabled-button': !goFromActiveCardsForSelf}" (click)="SelectFamilyDefintion('Mother In Law')"> 
                      <img *ngIf="familyDefitionArr.includes('Mother In Law')" src="/assets/images/checkedEndo.svg" width="18px"/> Mother In Law</button>
                    <button [attr.title]="!goFromActiveCardsForSelf ? infoMessage : ''"  [attr.disabled]="!goFromActiveCardsForSelf ? true : null"  [ngClass]="{'selectFamDivEndoBtn': !familyDefitionArr.includes('Father In Law'), 'selectFamDivEndoBtnInserted': familyDefitionArr.includes('Father In Law'),'disabled-button': !goFromActiveCardsForSelf}" (click)="SelectFamilyDefintion('Father In Law')"> 
                      <img *ngIf="familyDefitionArr.includes('Father In Law')" src="/assets/images/checkedEndo.svg" width="18px"/> Father In Law</button>
                  </ng-container>
                <p class="familyDefNotes" >Click above buttons to add details of family members  <img  src="/assets/images/thumbEndo.svg" width="18px"/></p>
                </ng-container>
              </div>
              <hr/>
              <div class="familyDetailsCardEndo my-3" *ngFor="let card of familyDefitionArr; let i=index">
                <!-- <hr/> -->
                  <div class="row"  >
                    <div class="col-md-4">
                      <label class="inputLabelsAddEndo">{{card}} Name <span class="text-danger">*</span></label>
                    <input class="inputForAddEmpEndo" (change)="handleFamilyData($event,i)" [value]="familyDataArr[i]&&familyDataArr[i].name?familyDataArr[i].name:''" name="name" placeholder="Name" type="text"/>  
                    </div>
                    <div class="col-md-4">
                      <label class="inputLabelsAddEndo">Date of Birth <span class="text-danger">*</span></label>
                    <input  class="inputForAddEmpEndo" *ngIf="!toggleForFam[i].toggleDateForSelf" (change)="handleFamilyData($event,i)" max="{{this.maxDate}}"  [value]="familyDataArr[i]&&familyDataArr[i].dob" name="dob" type="date" (keydown)="disableTyping($event)"/>  
                    <input  class="inputForAddEmpEndo" (focus)="focusDatesForFamDate($event,i)" *ngIf="toggleForFam[i].toggleDateForSelf"  [value]="familyDataArr[i]&&familyDataArr[i].dob | date: 'MMM d, y'"  type="text"/>  
                    </div>
                    <div class="col-md-4">
                      <label class="inputLabelsAddEndo">Gender <span class="text-danger">*</span></label>
                    <select class="inputForAddEmpEndo"(change)="handleFamilyData($event,i)" [value]="familyDataArr[i]&&familyDataArr[i].gender?familyDataArr[i].gender:''" name="gender"  placeholder="Gender" type="text">  
                      <option value="" selected>Select Gender</option>
                      <option value="Female">Female</option>
                      <option value="Male">Male</option>
                      <option value="Others">Others</option>
                    </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="inputLabelsAddEndo">Relationship <span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo"disabled (change)="handleFamilyData($event)" value="{{card}}" name="relation"> 
                    </div>
                    <div class="col-md-4" *ngIf="card==='Spouse'">
                      <label class="inputLabelsAddEndo">Date of Marriage <span class="text-danger">*</span></label>
                      <input  class="inputForAddEmpEndo" *ngIf="!toggleForFam[i].toggleDateForSelf" (change)="handleFamilyData($event,i)" max="{{this.maxDate}}"  [value]="familyDataArr[i]&&familyDataArr[i].marrdob" name="marrDob" type="date" (keydown)="disableTyping($event)"/>  
                      <input  class="inputForAddEmpEndo" (focus)="focusDatesForFamDate($event,i)" *ngIf="toggleForFam[i].toggleDateForSelf"  [value]="familyDataArr[i]&&familyDataArr[i].marrdob | date: 'MMM d, y'"  type="text"/>  
                    </div>
                   
                  </div>
                </div>
            </div>
          </div>
          <p class="text-danger text-center" *ngIf="errorMessageForAdding">{{errorMessageForAdding}}</p>
          <div class="buttonsDivAddEndo buttonsDivAddEndoFixed row p-1">
            <div class="col-md-6 stepperForEndo">
              <div>
              <div class="step active">1</div>
              <p class="blueSection">Self Details</p>
            </div>
              <div [ngClass]="{'line': true, 'activeLine': familyDetails}"></div>
              <div>
              <div [ngClass]="{'step': true, 'active': familyDetails}">2</div>
              <p [ngClass]="{'notABlueSection': !familyDetails, 'blueSection': familyDetails}">Family Details</p>
            </div>
              <div [ngClass]="{'line': true, 'activeLine': saveAndReviewBool}"></div>
              <div>
              <div [ngClass]="{'step': true, 'active': saveAndReviewBool}">3</div>
              <p [ngClass]="{'notABlueSection': !saveAndReviewBool, 'blueSection': saveAndReviewBool}">Review</p>
            </div>
          </div>
          
          <div class="col-md-6 endoBtnsDiv">
            <button type="button" class="clearAllBtn" (click)="clearAllFields()" data-dismiss="modal">Clear All</button>
            <button type="button" class="proceedAndReviewBtn" *ngIf="!saveAndReviewBool" class="btn btn-primary mx-3" (click)="saveAndReview()">Proceed & Review</button>
            <button type="button" *ngIf="saveAndReviewBool" class="btn btn-primary mx-3" (click)="saveDetailsFunc()">Save Details</button>
          </div>
        </div>
      </div>

        <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': proceedAndReviewBool ? 'block' : 'none' }">
          <div class="modal-dialog modal-md" style="min-width: 30%;top:30%" role="document">
            <div class="modal-content">
              <div class='tableHeadingSurvey'>
                Alert
                  <p (click)="closePreviewAndReview()">&times;</p>
              </div>
              <div class="modal-body deleteModalEndo">
               Are you sure you want to proceed and review?
              </div>
              <div class="modalButtonsEndo p-2">
                <button class="btn btn-primary mr-1" (click)="proceedAndReview()">Yes</button>
                <button  class="btn btn-danger"(click)="closePreviewAndReview()">No</button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ 'display': saveDetailsBool ? 'block' : 'none' }">
          <div class="modal-dialog modal-md" style="min-width: 30%;top:30%" role="document">
            <div class="modal-content">
              <div class='tableHeadingSurvey'>
                Alert
                  <p (click)="closeSaveDetailsFunc()">&times;</p>
              </div>
              <div class="modal-body deleteModalEndo">
               Are you sure you want to save details?
              </div>
              <div class="modalButtonsEndo p-2">
                <button class="btn btn-primary mr-1" (click)="submitEmployeeData()">Yes</button>
                <button  class="btn btn-danger"(click)="closeSaveDetailsFunc()">No</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
   </div>
 </div>
 <div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>
</section>
